import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IDriverBreak extends IBaseEntity {
    id?: number;
    driverName?: any;
    driverId?: number;
    duration?: number;
    startTime?: Date;
    endTime?: Date;
    latitude?: number;
    longitude?: number;
}

export class DriverBreak extends BaseEntity implements IDriverBreak {
    id?: number;
    driverName?: any;
    driverId?: number;
    duration?: number;
    startTime?: Date;
    endTime?: Date;
    latitude?: number;
    longitude?: number;

    constructor(driverRequest?) {
        super();
        if (driverRequest) {
            this.id = driverRequest.id;
            this.driverId = driverRequest.driverId;
            this.driverName = driverRequest.driverName;
            this.duration = driverRequest.duration;
            this.startTime = driverRequest.startTime;
            this.endTime = driverRequest.endTime;
            this.latitude = driverRequest.latitude;
            this.longitude = driverRequest.longitude;
        }
    }

    clone(): DriverBreak {
        return new DriverBreak(this);
    }

    get discriminator(): any {
        return this.id;
    }
}
